export default __webpack_public_path__ + "locales/lo-LA/Webhooks.json?hash=f655e3028a23ce4255c6a82be114cd97";